module.exports = __webpack_public_path__ + "static/media/loginbackground.7419dbd6.svg";